import React from 'react';
import { Box, Divider } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import Text from '../../../components/UI/atoms/Text';

export default function AdminNav() {
  const { pathname } = useLocation();

  const navLink = (label, to) => {
    const active = pathname === to || pathname.startsWith(to + '/');
    return (
      <Link to={to} style={{ textDecoration: 'none' }}>
        <Text
          sx={{
            fontSize: '14px',
            fontWeight: active ? 700 : 400,
            color: active ? 'primary.main' : 'text.secondary',
            paddingBottom: '4px',
            borderBottom: active ? '2px solid' : '2px solid transparent',
            borderColor: active ? 'primary.main' : 'transparent',
            transition: 'all 0.15s',
            '&:hover': { color: 'primary.main' },
          }}
        >
          {label}
        </Text>
      </Link>
    );
  };

  return (
    <Box sx={{ mb: '28px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px', pb: '10px' }}>
        <Text
          sx={{
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'text.disabled',
            mr: '8px',
          }}
        >
          Admin Portal
        </Text>
        {navLink('Firms', '/admin/firms')}
        {navLink('Reports', '/admin/reports')}
      </Box>
      <Divider />
    </Box>
  );
}
